import { makeStyles } from '@material-ui/styles'
import FontAwesomeIcon from 'pf9-ui-components/built/components/FontAwesomeIcon'
import Text from 'pf9-ui-components/built/elements/Text'
import React from 'react'
import Theme from 'core/themes/model'
import Tooltip from './Tooltip'

const useStyles = makeStyles<Theme>((theme) => ({
  hint: {
    cursor: 'help',
    transition: 'color .2s ease',
    color: theme.components.input.label.hint,
    '& i': {
      cursor: 'help',
      marginRight: 8,
      transition: 'color .2s ease',
      color: theme.components.input.label.hint,
      '&:hover': { color: theme.palette.grey[700] },
    },
  },
}))

type HintTooltipProps = {
  message?: string | React.ReactNode
  align?: any
  offset?: any
  origin?: string
  className?: string
  customClassName?: string
  dataTestId?: string
  customBody?: React.ReactNode
}

const HintTooltip: React.FC<HintTooltipProps> = ({
  message,
  align,
  offset,
  origin,
  className,
  customClassName,
  dataTestId,
  customBody,
}) => {
  const classes = useStyles()
  return (
    <Tooltip
      message={message}
      align={align}
      offset={offset}
      origin={origin}
      className={className}
      customClassName={customClassName}
      customBody={customBody}
    >
      <Text variant="inputLabel" className={className || classes.hint} data-testid={dataTestId}>
        <FontAwesomeIcon>info-circle</FontAwesomeIcon>
      </Text>
    </Tooltip>
  )
}

export default HintTooltip
